module.exports = __webpack_public_path__ + "static/ni-logo-789aad07d19409b74ca8506cd6d0066f.jpg";